"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emitter = _interopRequireDefault(require("element-ui/lib/mixins/emitter"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('li', {
    staticClass: "el-dropdown-menu__item",
    "class": {
      'is-disabled': _vm.disabled,
      'el-dropdown-menu__item--divided': _vm.divided
    },
    attrs: {
      "aria-disabled": _vm.disabled,
      "tabindex": _vm.disabled ? null : -1
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default", null, {})], 2);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElDropdownItem',
  mixins: [_emitter["default"]],
  props: {
    command: {},
    disabled: Boolean,
    divided: Boolean
  },
  methods: {
    handleClick: function handleClick(e) {
      if (this.disabled) {
        return;
      }

      this.dispatch('ElDropdown', 'menu-item-click', [this.command, this]);
    }
  }
};
exports["default"] = _default;